import { BaseDto } from './base.dto';
import { CardDataDto } from './cardData.dto';
import { CustomerPaymentTypeDto } from './customerPaymentType.dto';
import { MerchantPaymentMethodDto } from './merchantPaymentMethod.dto';
import { MerchantDto } from './merchant.dto';
import { PaymentDonationDto } from './paymentDonation.dto';
import { BankAibMIDDto } from './bank-aib.mid.dto';

export class PaymentDto extends BaseDto {
  customerPaymentMethod: CustomerPaymentTypeDto;
  authorizedAmount: number;
  settledAmount: number;
  success: boolean;
  approvalCode: string;
  message: string;
  data: CardDataDto;
  merchantPaymentMethod?: MerchantPaymentMethodDto;
  merchant: MerchantDto;
  paymentDonations?: PaymentDonationDto[];
  stripeConnectWasUsed?: boolean;
  aibConnectWasUsed?: boolean;
  bankAibMIDId?: number;
  bankAibMID?: BankAibMIDDto;
}
